import { useCallback } from 'react';
import {
  NavigateOptions,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';

export const useNavigateInApp = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return useCallback(
    (path: string, options?: NavigateOptions) =>
      navigate(
        {
          pathname: path,
          search: `${searchParams.toString()}`,
        },
        options,
      ),
    [navigate, searchParams],
  );
};

export { useEjectBattery } from './useEjectBattery';
export { useMutationDeletePaymentMethod } from './useMutationDeletePaymentMethod';
export { useMutationLoginDirect } from './useMutationLoginDirect';
export { useMutationRedeemReward } from './useMutationRedeemReward';
export { useMutationRequestBattery } from './useMutationRequestBattery';
export { useMutationUpdateUserPassStatus } from './useMutationUpdateUserPassStatus';
export { useQueryGetCampusCardBalance } from './useQueryGetCampusCardBalance';
export { useQueryGetCurrentSubscription } from './useQueryGetCurrentSubscription';
export { useQueryGetInstitution } from './useQueryGetInstitution';
export { useQueryGetUserPassDetail } from './useQueryGetUserPassDetail';
export { useQueryListInstitutions } from './useQueryListInstitutions';
export { useRedeemReward } from './useRedeemReward';
export { useUserAgent } from './useUserAgent';
